import { Button, styled } from '@mui/material';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import IdentificacaoEvento from 'esocial.web.react.lib/cjs/components/util/IdentificacaoEvento';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { getStringValue } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";

const ContainerBotoesPagina = styled('div')`
    margin: 48px 0 0;
    display: flex;
`;

function InfoEmpregadorRegistro() {
    const [modelo, setModelo] = useState(null);

    const navigate = useNavigate();

    // Hook personalizado para requisições ao servidor
    const { get } = useRequisicaoControlada();

    const processamentoResposta = (conteudoResposta) => {
        setModelo({
            ...conteudoResposta,
            descricaoClassificacaoTributaria: { ...conteudoResposta.descricaoClassificacaoTributaria, tipo: 'C' }
        });
    };

    async function inicializarModelo() {
        await get(`infoempregador/consultar`, processamentoResposta);
    }

    useEffect(() => {
        inicializarModelo();
    }, []);

    return (
        modelo !== null ?
            <Fragment>
                <TituloPagina>Dados do Empregador</TituloPagina>

                <Fieldset legend="Período de validade das Informações" spacing={4}>
                    <VepDatePicker
                        accessor="inicioValidade"
                        model={modelo}
                        setModel={setModelo}
                        md={4}
                        format="MM/yyyy"
                    />
                    <VepDatePicker
                        accessor="fimValidade"
                        model={modelo}
                        setModel={setModelo}
                        format="MM/yyyy"
                        md={4}
                    />
                </Fieldset>

                <Fieldset legend="Informações do Empregador" spacing={4}>
                    <VepTextField
                        accessor="numeroInscricao"
                        model={modelo}
                        md={3}
                        maskPattern={modelo.tipoInscricao === 1 ? Mascara.CNPJ : Mascara.CPF}
                        maxLength={18}
                    />
                    <VepTextField
                        accessor="nomeRazaoSocial"
                        model={modelo}
                        md={9}
                    />
                    <VepTextField
                        accessor="descricaoClassificacaoTributaria"
                        model={modelo}
                        md={6}
                        type="text"
                    />
                    <Display show={modelo.tipoInscricao === 1}>
                        <VepTextField
                            accessor="descricaoNaturezaJuridica"
                            model={modelo}
                            md={6}
                            type="text"
                        />
                    </Display>
                    <Display show={modelo.tipoInscricao === 1}>
                        <VepSelect
                            accessor="indicativoCooperativa"
                            model={modelo}
                            md={3}
                        />
                    </Display>

                    {
                        getStringValue(modelo.descricaoClassificacaoTributaria.valor).length > 0 &&
                        <Display show={modelo.descricaoClassificacaoTributaria.valor.startsWith('07') || modelo.descricaoClassificacaoTributaria.valor.startsWith('21')}>
                            <VepSelect
                                accessor="indicativoOpcaoProdutorRural"
                                model={modelo}
                                md={9}
                            />
                        </Display>
                    }

                    {
                        getStringValue(modelo.descricaoNaturezaJuridica.valor).length > 0 &&
                        <Display show={modelo.tipoInscricao === 1 && modelo.descricaoNaturezaJuridica.valor.startsWith('1')}>
                            <VepTextField
                                accessor="cnpjEnteFederativo"
                                model={modelo}
                                md={4}
                                label="CNPJ da Entidade Federativa Responsável"
                                maskPattern={Mascara.CNPJ}
                                maxLength={18}
                            />
                        </Display>
                    }
                </Fieldset>

                <IdentificacaoEvento idEventoXml={modelo.idEventoXml} numeroRecibo={modelo.numeroRecibo} />

                <ContainerBotoesPagina>
                    <Button variant="outlined" color="secondary" size="medium" onClick={() => navigate('/')}>
                        Voltar
                    </Button>
                </ContainerBotoesPagina>
            </Fragment> :
            <ContentPreview />
    );
}

export default InfoEmpregadorRegistro;
